import React from "react";
import { Box, Flex, Text } from "@chakra-ui/react";
import { Navigate, Route, Routes } from "react-router-dom";
import routes from "routes";
import { useNavigate } from "react-router-dom";

export default function MainLayout() {
  const navigate = useNavigate();

  const logOut = async () => {
      const token =
    localStorage.getItem("sessionToken") ??
    sessionStorage.getItem("sessionToken");
    if (token) {
      localStorage.removeItem("sessionToken");
      sessionStorage.removeItem("sessionToken");
      navigate("/auth/login");
    }
  };

  const getRoutes = () => {
    return routes
      .filter((route) => route.layout === "/main")
      .map((route, index) => (
        <Route key={index} path={route.path} element={route.element} />
      ));
  };

  return (
    <Box w="100%" minH="100vh">
      <Flex
        as="header"
        align="center"
        justify={"space-between"}
        h="50px"
        px={8}
        bg="white"
        boxShadow="sm"
      >
        <Text fontWeight="bold" fontSize="xl" letterSpacing={2} color="red.500">
          PDF TEXT REPLACER
        </Text>
        <Text
          cursor="pointer"
          _hover={{
            transform: "scale(1.03)",
            color: "red.500",
            textDecoration: "underline",
          }}
          onClick={logOut}
        >
          Logout
        </Text>
      </Flex>
      <Box as="main" height="calc(100vh - 50px)" pt={4} px={{ base: 2, md: 8 }}>
        <Routes>
          {getRoutes()}
          <Route
            path="*"
            element={<Navigate to="/main/pdf-text-replacer" replace />}
          />
        </Routes>
      </Box>
    </Box>
  );
}
